import { newsDelete, newsListingByid, newsStatusUpdate } from "api/news";
import DateTime from "components/Modal/DateTime";
import PublishNotification from "components/Modal/PublishNotification";
import RejectNews from "components/Modal/RejectNews";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ModalComp from "themes/elements/Modal";
import Content from "./components/content";
import ContentInfo from "./components/contentInfo";
import DeleteModalFooter from "./components/deleteModalFooter";
import Header from "./components/header";
import style from "./details.module.scss";
import { createNewsForm } from "./helper";

function DetailsPage({
  setOpen,
  onEdit = () => {},
  Approval,
  selectedNews,
  setLoadTable,
  fetchNews = () => {},
  isHistory,
  tabActive,
  setSelectedNews,
}) {
  const [reject, setReject] = useState(false);
  const [approve, setApprove] = useState(false);
  const [schedule, setSchedule] = useState(false);

  const [status, setStatus] = useState(null);
  const [publish, setPublish] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [dlt, setDlt] = useState(false);
  const [formData, setFormData] = useState({
    id: selectedNews?.id,
    schedule_publish: false,
    remark: "",
    resubmission_flg: false,
    schedule_date: null,
    schedule_time: null,
  });

  const fetchNewsId = async () => {
    if (selectedNews) {
      const response = await newsListingByid(
        1,
        10,
        selectedNews?.id,
        Approval ? 0 : 1
      );
      const data = response.news[0];
      const formattedData = {
        id: data?.news_id,
        title: data?.title,
        avatar: null,
        category: data?.news_category_name,
        author: data?.author_name,
        authorIcon: data?.author_image,
        publisheddate: data?.published_date || "NA",
        status: data?.news_status_flg,
        expirydate: data?.expiry_date || "NA",
        expirydatetime: data?.expiry_date_time || null,
        message: data?.message_content,
        recipients_flg: data?.recipients_flg,
        source: data?.source,
        wards: data?.wards,
        abstract_content: data?.abstract_content ? data?.abstract_content : "",
        image_caption: data?.image_caption,
        category_id: data?.news_category_id,
        activity: data?.activities,
        banner_img: data?.news_image,
        allow_resubmission_flg: data?.allow_resubmission_flg,
        author_image: data?.author_image,
        published_date_time: data.published_date_time,
        scheduled_date: data?.scheduled_date,
        tabDate:
          tabActive === "1"
            ? data?.published_date_time
            : tabActive === "2"
            ? data?.published_date_time
            : tabActive === "3"
            ? data?.scheduled_date
            : tabActive === "4"
            ? data?.activities[0]?.date
            : data?.activities[0]?.date,
        top_news: data.top_news_flg,
        tag_color: data?.tag_color,
        news_image_filepath: data?.news_image_filepath,
        author_image_path: data?.author_image_filepath,
      };
      setSelectedNews(formattedData);
    }
  };

  useEffect(() => {
    fetchNewsId();
  }, [status]);

  useEffect(() => {
    if (Approval && tabActive === "2" && selectedNews?.scheduled_date) {
      // Format the scheduled_date from selectedNews into the desired format
      const formattedDate = dayjs(selectedNews.scheduled_date).format(
        "DD-MM-YYYY, hh:mm A"
      );

      // Set the form data with schedule_publish as true and schedule_date formatted
      setFormData({
        ...formData,
        schedule_publish: true,
        schedule_date: formattedDate, // You set the formatted date here
        schedule_time: dayjs(selectedNews.scheduled_date).format("hh:mm A"), // Set the time in desired format
      });
    }
  }, []); // Dependency on Approval, tabActive, and selectedNews

  const handleClose = () => {
    setOpen(false);
  };

  const updateStatus = async (formData, type) => {
    try {
      const response = await newsStatusUpdate(formData);
      if (response?.statusCode === 200) {
        toast.success(response.message);
        setLoading(false);
        const normalizedType = type.trim().toLowerCase();
        switch (normalizedType) {
          case "approved":
            if (!formData.is_scheduled_flg && !schedule) {
              handleClose();
            }
            setStatus("approved");
            setApprove(false);
            break;
          case "reject":
            setStatus("reject");
            setReject(false);
            break;
          case "schedule":
            setStatus("approved");
            setSchedule(false);
            break;
          case "publish":
            setStatus("publish");
            setPublish(false);
            break;
        }
        setReject(false);
        setApprove(false);
        setSchedule(false);
        setPublish(false);
        fetchNews();
        setLoadTable((prev) => !prev);
      } else {
        fetchNews();
        toast.error(response.message);
        setLoading(false);
      }
    } catch (error) {
      fetchNews();
      setLoading(false);
      setReject(false);
      setApprove(false);
      setSchedule(false);
      setPublish(false);
    }
  };

  const handleNewsDelete = async (newsId) => {
    setLoading(true);
    try {
      const response = await newsDelete({
        newsId: Number(newsId),
      });
      fetchNews();
      toast.success(response.message);
      handleClose();
      setLoading(false);
    } catch (error) {
      toast.error(error);
      setLoading(false);
    }
  };

  const handleButtonClick = async (type) => {
    if (selectedNews) {
      setLoading(true);
      const form = createNewsForm(selectedNews, type);
      if (type === "reject") {
        form.remarks = formData.remark;
        if (formData.resubmission_flg) {
          form.allow_resubmission_flg = 1;
        }
      }
      if (type === "publish") {
        form.is_scheduled_flg = formData.schedule_publish ? 1 : 0;
        if (formData.schedule_publish) {
          var date = dayjs(formData.schedule_date, "DD/MM/YYYY");
          var FormattedDate = date.format("YYYY-MM-DD");
          form.scheduled_date = `${FormattedDate} ${formData.schedule_time}`;
        }
      }
      if (type === "schedule") {
        form.is_scheduled_flg = formData.schedule_publish ? 1 : 0;
        if (formData.schedule_publish) {
          var date = dayjs(formData.schedule_date, "DD/MM/YYYY");
          var FormattedDate = date.format("YYYY-MM-DD");
          form.scheduled_date = `${FormattedDate} ${formData.schedule_time}`;
        }
      }
      if (form) {
        await updateStatus(form, type);
        fetchNewsId();
      } else {
        fetchNewsId();

        setLoading(false);
      }
    }
  };

  const checkSchedule = () => {
    const { schedule_date, schedule_time } = formData;

    if (!schedule_date || !schedule_time) {
      return true;
    }
  };

  return (
    <>
      <div className="w-full flex flex-column">
        {/* Header */}
        <div
          className={`flex gap-2 align-center w-full justify-between ${style["header-wrapper"]}`}
        >
          <Header
            handleClose={handleClose}
            selectedNews={selectedNews}
            isHistory={isHistory}
            Approval={Approval}
            onEdit={onEdit}
            setReject={setReject}
            status={status}
            setApprove={setApprove}
            setDlt={setDlt}
            tabActive={tabActive}
          />
        </div>
        <div className={style["body-wrapper"]}>
          {/* Left Section : Content */}
          <div className={style["left-section"]}>
            <Content
              Approval={Approval}
              status={status}
              selectedNews={selectedNews}
              isSchedule={checkSchedule()}
              setSchedule={setSchedule}
              setFormData={setFormData}
              setPublish={setPublish}
              formData={formData}
              tabActive={tabActive}
            />
          </div>
          <div className={style["right-section"]}>
            {/* Right Section (Content Info) : Status, Image caption:,
             Author, Recipients, Source, Created date, Expiry date & time, Activity log  */}
            <ContentInfo selectedNews={selectedNews} />
          </div>
        </div>
      </div>
      {/* Reject News Modal */}
      <RejectNews
        isLoading={isLoading}
        setFormData={setFormData}
        formData={formData}
        open={reject}
        setOpen={setReject}
        onSubmit={() => {
          handleButtonClick("reject");
        }}
      />
      {/* Approve Artilcle / Change Schedule date Modal */}
      <DateTime
        Approval={Approval}
        tabActive={tabActive}
        expiryDate={selectedNews?.expirydate}
        formData={formData}
        setFormData={setFormData}
        isLoading={isLoading}
        change={schedule}
        open={schedule ? schedule : approve}
        setOpen={schedule ? setSchedule : setApprove}
        onSubmit={() => {
          if (formData?.schedule_publish) {
            handleButtonClick("schedule");
          } else {
            handleButtonClick("publish");
          }
        }}
        onCancel={() => {
          if (schedule) {
            setStatus("approved");
          }
        }}
      />
      {/* Publish Article  confirmation modal */}
      <PublishNotification
        isLoading={isLoading}
        newsArticle
        title="Publish News Article"
        item={selectedNews?.title}
        onSubmit={() => {
          handleButtonClick("publish");
        }}
        open={publish}
        setOpen={setPublish}
      />
      {/* Delete News confirmation modal */}
      <ModalComp
        footer={
          <DeleteModalFooter
            setDlt={setDlt}
            handleNewsDelete={handleNewsDelete}
            formData={formData}
            isLoading={isLoading}
          />
        }
        CancelClick={() => setDlt(false)}
        open={dlt}
        setOpen={setDlt}
        title="Delete News"
      >
        Are you sure you want to delete the news titled '{selectedNews?.title}'
      </ModalComp>
    </>
  );
}

export default DetailsPage;
